module.exports = __webpack_public_path__ + "static/link-somewhereelse-dont-9017259ebcdf137363fde55396e47484.png";